import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import AutoFixHighRoundedIcon from '@mui/icons-material/AutoFixHighRounded';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';
import SettingsSuggestRoundedIcon from '@mui/icons-material/SettingsSuggestRounded';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';
import ThumbUpAltRoundedIcon from '@mui/icons-material/ThumbUpAltRounded';
import { HighQualityRounded } from '@mui/icons-material';
import SectionHeading from './SectionHeading';
import SpotlightCard from './SpotlightCard';
import { Stagger } from './motion/Reveal';

const items = [
  {
    icon: <SettingsSuggestRoundedIcon />,
    title: 'Adaptable performance',
    description:
      'Designed for seamless performance, ensuring reliability and efficiency in every use case.',
  },
  {
    icon: <ConstructionRoundedIcon />,
    title: 'Built to last',
    description: 'Crafted with precision to deliver a premium experience tailored to your needs.',
  },
  {
    icon: <ThumbUpAltRoundedIcon />,
    title: 'Great user experience',
    description:
      'Innovative solutions that anticipate your challenges and make your workflow effortless.',
  },
  {
    icon: <AutoFixHighRoundedIcon />,
    title: 'Innovative functionality',
    description: 'Built with cutting-edge technology to keep you ahead in a fast-paced world.',
  },
  {
    icon: <SupportAgentRoundedIcon />,
    title: 'Reliable support',
    description:
      'A perfect blend of functionality and style, delivering both performance and aesthetics.',
  },
  {
    icon: <QueryStatsRoundedIcon />,
    title: 'Precision in every detail',
    description: 'Enhance productivity with a solution that is as powerful as it is easy to use.',
  },
  {
    icon: <HighQualityRounded />,
    title: 'Xcellence in Quality',
    description:
      'Our commitment to quality ensures an experience that exceeds expectations every time.',
  },
];

export default function WhyChooseUs() {
  return (
    <Box id="why-choose-us" sx={{ pt: { xs: 6, sm: 12 }, pb: { xs: 8, sm: 16 } }}>
      <Container sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 4, sm: 7 } }}>
        <SectionHeading
          eyebrow="Why FalconXcellence"
          title="Excellence, in"
          highlight="every detail"
          subtitle="We deliver high-quality software across full-stack web, mobile, desktop, cloud, and distributed systems — obsessing over performance, security, and the details that make products feel effortless."
        />

        <Stagger>
          <Grid container spacing={2.5}>
            {items.map((item, index) => (
              <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                <SpotlightCard>
                  <Box sx={{ p: 3.5, height: '100%', display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                    <Box
                      sx={{
                        flexShrink: 0,
                        width: 46,
                        height: 46,
                        borderRadius: 2,
                        display: 'grid',
                        placeItems: 'center',
                        color: 'primary.main',
                        background:
                          'linear-gradient(135deg, hsla(210,98%,55%,0.16), hsla(265,90%,62%,0.06))',
                        border: '1px solid',
                        borderColor: 'hsla(210,98%,55%,0.28)',
                        '& svg': { fontSize: 22 },
                      }}
                    >
                      {item.icon}
                    </Box>
                    <Box>
                      <Typography sx={{ fontWeight: 700, mb: 0.5 }}>{item.title}</Typography>
                      <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.6 }}>
                        {item.description}
                      </Typography>
                    </Box>
                  </Box>
                </SpotlightCard>
              </Grid>
            ))}
          </Grid>
        </Stagger>
      </Container>
    </Box>
  );
}
